module.exports = __webpack_public_path__ + "static/media/budget.b705a4b8.png";